import React, { Component } from 'react';
import { REJECTED_REASONS } from '../../../../../../constants/app/inspection';

const Reject = ({ handleChangeRejected = () => {}, state = '' }) => {
	if (state.length && state === 'SENT') {
		return (
			<div className="main-reject pt20">
				<span className="text-md mb20">Por favor, confirma la derivación a presencial de la inspección para que sea comunicada.</span>			
			</div>
		)
	}
	return(
		<div className="main-reject pt20">
		<span className="text-lg generate">Selecciona uno o más motivos de rechazo:</span>
			<div className="reasons-rejected">
			{
							REJECTED_REASONS.map((rejected, index) => (
								<div key={index}>
									<input
										id={"rejected-"+ rejected.id}
										onChange={handleChangeRejected.bind(this, {id: rejected.id, label: rejected.label})}
										type="checkbox"
                                        className="ui-form-control"
									/>
									<label for={"rejected-"+ rejected.id}>{rejected.label}</label>
								</div> 
							))
						}
			</div>
			<span className="text-md mb20">Por favor, confirma el rechazo de la inspección para que sea comunicada.</span>
		</div>
	)
}
export default Reject;



// WEBPACK FOOTER //
// ./src/components/app/dashboard/inspection/components/resolve/form-reject.js